const state = {
    payments: [],
    loading: false
};

export default state;